/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import auth from './auth/authService'

import firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(Router)

const ifAuthenticated = async (to, from, next) => {
  if (localStorage.getItem('accessToken') && (localStorage.getItem('accessToken') !== null) && localStorage.getItem('accessToken').length) {
    next()
    return
  }
  next('/login')
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          redirect: '/dashboard'
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          beforeEnter: ifAuthenticated,
          component: () => import('./views_moozimed/dashboard/dashboard.vue'),
          meta: {
            rule: 'editor'
          }
        },

        // =============================================================================
        // ------- Start MooZiSupport Application Routes -------------------------------
        // =============================================================================


        {
          path: '/Utilisateurs',
          beforeEnter: ifAuthenticated,
          name: 'users',
          component: () => import('./views_moozimed/users/DataListListView.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/Inscrits',
          beforeEnter: ifAuthenticated,
          name: 'Inscrits',
          component: () => import('./views_moozimed/inscrits/DataListInscritsView.vue'),
          meta: {
            rule: 'editor'
          }
        },
        /* {
          path: '/Agents',
          beforeEnter: ifAuthenticated,
          name: 'Agents',
          component: () => import('./views_moozimed/agents/DataListagent.vue'),
          meta: {
            rule: 'editor'
          }
        }, */
        {
          path: '/Cards',
          beforeEnter: ifAuthenticated,
          name: 'Cards',
          component: () => import('./views_moozimed/cards/DataListCardsVIew.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/CardsView',
          beforeEnter: ifAuthenticated,
          name: 'CardsView',
          component: () => import('./views_moozimed/cards/CardsView.vue'),
          meta: {
            rule: 'editor'
          }
        },
        /*  {
          path: '/PasswordReset',
          beforeEnter: ifAuthenticated,
          name: 'PasswordReset',
          component: () => import('./views_moozimed/PasswordReset/DataListpasswordReset.vue'),
          meta: {
            rule: 'editor'
          }
        }, */
        /*  {
          path: '/Localities',
          beforeEnter: ifAuthenticated,
          name: 'Localities',
          component: () => import('./views_moozimed/localities/DataListLocalitiesView.vue'),
          meta: {
            rule: 'editor'
          }
        }, */

        {
          path: '/Countries',
          beforeEnter: ifAuthenticated,
          name: 'Countries',
          component: () => import('./views_moozimed/countries/DataListCountries.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/Regions',
          beforeEnter: ifAuthenticated,
          name: 'Regions',
          component: () => import('./views_moozimed/regions/DataListRegions.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/Branches',
          beforeEnter: ifAuthenticated,
          name: 'Branches',
          component: () => import('./views_moozimed/branches/DataListBranches.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/Corporates',
          beforeEnter: ifAuthenticated,
          name: 'Corporates',
          component: () => import('./views_moozimed/corporates/DataListCorporates.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/HealthFacilities',
          beforeEnter: ifAuthenticated,
          name: 'HealthFacilities',
          component: () => import('./views_moozimed/healthFacilities/DataListHealthFacilities.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/Actes',
          beforeEnter: ifAuthenticated,
          name: 'Actes',
          component: () => import('./views_moozimed/actes/DataListActes.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/ActeTypes',
          beforeEnter: ifAuthenticated,
          name: 'ActeTypes',
          component: () => import('./views_moozimed/actTypes/DataListActeTypes.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/Letters',
          beforeEnter: ifAuthenticated,
          name: 'Letters',
          component: () => import('./views_moozimed/letters/DataListLetters.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: 'Profil',
          name: 'page-Profil',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/pages/login/MonProfil'),
          meta: {
            rule: 'editor'
          }
        },

        {
          path: '/Profile',
          name: 'Profile',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/pages/login/MonProfile'),
          meta: {
            rule: 'editor'
          }
        }

      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('./layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        
        {
          path: '/login',
          name: 'page-login',
          component: () => import('./views/pages/login/Login.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/Changelogin',
          name: 'Changelogin',
          component: () => import('./views/pages/login/Changelogin.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/forgot-password',
          name: 'forgot-password',
          component: () => import('./views/pages/ForgotPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/reset-password',
          name: 'password-reset',
          component: () => import('./views/pages/ResetPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        /*   {
          path: '/pages/forgot-password',
          name: 'page-forgot-password',
          component: () => import('./views/pages/ForgotPassword.vue'),
          meta: {
            rule: 'editor'
          }
        }, */
        /* {
          path: '/pages/reset-password',
          name: 'page-reset-password',
          component: () => import('./views/pages/ResetPassword.vue'),
          meta: {
            rule: 'editor'
          }
        }, */
        /* 
        {
          path: '/pages/register',
          name: 'page-register',
          component: () => import('./views/pages/register/Register.vue'),
          meta: {
            rule: 'editor'
          }
        },
        
        {
          path: '/pages/lock-screen',
          name: 'page-lock-screen',
          component: () => import('./views/pages/LockScreen.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/comingsoon',
          name: 'page-coming-soon',
          component: () => import('./views/pages/ComingSoon.vue'),
          meta: {
            rule: 'editor'
          }
        }, */
        {
          path: '/error-404',
          name: 'error-404',
          component: () => import('./views/pages/Error404.vue'),
          meta: {
            rule: 'editor'
          }
        }
        /*  {
          path: '/pages/error-500',
          name: 'page-error-500',
          component: () => import('./views/pages/Error500.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('./views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/maintenance',
          name: 'page-maintenance',
          component: () => import('./views/pages/Maintenance.vue'),
          meta: {
            rule: 'editor'
          } 
        }*/
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(() => {

    // get firebase current user
    const firebaseCurrentUser = firebase.auth().currentUser

    // If auth required, check login. If login fails redirect to login page
    if (to.meta.authRequired) {
      if (!(auth.isAuthenticated() || firebaseCurrentUser)) {
        router.push({ path: '/login', query: { to: to.path } })
      }
    }

    return next()
    // Specify the current path as the customState parameter, meaning it
    // will be returned to the application after auth
    // auth.login({ target: to.path });

  })

})

export default router
